type AttachmentToastAction = 'create' | 'delete' | 'feature' | 'update';

type GetAttachmentToastMessageParams = {
  action: AttachmentToastAction;
  featureError?: boolean;
  isImage: boolean;
  success: boolean;
};

export const getAttachmentToastMessage = (params: GetAttachmentToastMessageParams): string => {
  const { action, featureError, isImage, success } = params;

  if (action === 'feature') {
    return success ? 'Featured image updated.' : 'Failed to update featured image.';
  }

  if (action === 'delete') {
    if (success) {
      return isImage ? 'Technology image removed.' : 'Attachment removed.';
    }

    return isImage ? 'Failed to remove technology image.' : 'Failed to remove attachment.';
  }

  if (action === 'update') {
    if (!success) {
      return isImage ? 'Failed to save technology image.' : 'Failed to save attachment.';
    }

    if (featureError) {
      return 'Attachment updated, but failed to set as featured image.';
    }

    return 'Attachment updated successfully.';
  }

  // action === 'create'
  if (!success) {
    return isImage ? 'Failed to save technology image.' : 'Failed to save attachment.';
  }

  if (featureError) {
    return 'Image uploaded, but failed to set as featured.';
  }

  return isImage ? 'Technology image uploaded.' : 'Attachment uploaded successfully.';
};
